import { REPORT_USER_TYPES } from '@/helpers/deleted-report-helpers'

export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    header: 'Navigation',
  },
  {
    title: 'Files',
    route: 'files',
    icon: 'FileIcon',
  },
  {
    title: 'Test',
    route: 'test',
    icon: 'StarIcon',
    tag: 'new',
  },
  {
    title: 'Group',
    route: 'group',
    icon: 'FileIcon',
  },
  {
    title: 'User',
    route: 'user',
    icon: 'UserIcon',
  },
  {
    header: 'Report',
    userTypes: REPORT_USER_TYPES,
  },
  {
    title: 'Report cartelle eliminate',
    route: 'deleted-report',
    icon: 'FileTextIcon',
    userTypes: REPORT_USER_TYPES,
  },
]
